<template>
  <div class="related">
    <Loading/>
    <div data-simplebar data-simplebar-auto-hide="false" style="height: 100%;">
      <transition-group name="fade" tag="ul" class="products" >
      <li v-for="product in getRelated" class="product" :key="product.id" @click.stop="selectProduct(product)">
          <div class="top-bar">
            <transition name="fade">
              <div class="quantity-input" @click.stop v-if="selectedProducts.find(item => item.id === product.id)">
                <button class="increase" @click.stop="changeQuantityValue('minus', product)"
                        :disabled="selectedProducts.find(item => item.id === product.id).quantity <= 1">
                  <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="12" height="2" rx="1" fill="#3C3C3C"/>
                  </svg>
                </button>
                <span class="input-value"
                      v-html="selectedProducts.find(item => item.id === product.id).quantity"></span>
                <button class="decrease" @click.stop="changeQuantityValue('plus', product)">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M6 0C5.44772 0 5 0.447715 5 1L5 5L1 5C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7L5 7L5 11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11L7 7L11 7C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5L7 5L7 1C7 0.447715 6.55228 0 6 0Z"
                          fill="#252525"/>
                  </svg>
                </button>
              </div>
            </transition>
            <div class="checkbox" :class="{ 'selected' : selectedProducts.find(item => item.id === product.id) }">
              <label>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M3.70711 9.2929C3.31658 8.90238 2.68342 8.90238 2.29289 9.2929C1.90237 9.68343 1.90237 10.3166 2.29289 10.7071L7.29289 15.7071C7.69802 16.1122 8.36002 16.0948 8.74329 15.669L17.7433 5.66897C18.1128 5.25846 18.0795 4.62617 17.669 4.25671C17.2585 3.88726 16.6262 3.92053 16.2567 4.33104L7.96181 13.5476L3.70711 9.2929Z"
                        fill="#3C3C3C"/>
                </svg>
              </label>
            </div>
          </div>
          <div class="image">
            <img :src="product.image"/>
          </div>
          <div class="details">
            <p class="name">{{ product.name }}</p>
            <p class="price">{{ product.price | price }}</p>
          </div>
      </li>
    </transition-group>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from "vuex";
import Loading from './misc/Loading';

export default {
  name: "ProductRelated",
  components: {Loading},
  filters: {
    price(price) {
      if (!price) {
        return 'b.d'
      }
      return new Intl.NumberFormat('pl-PL', {style: 'currency', currency: 'PLN'}).format(price)
    }
  },
  data() {
    return {
      selectedProducts: []
    }
  },
  computed: {
    ...mapGetters({
      getOptions: 'customizer/getOptions',
      getRelated: 'customizer/getRelated'
    }),
    getStep() {
      return this.$parent.getStep
    },
    getSteps() {
      return this.$parent.getSteps
    }
  },
  mounted() {
    if (this.getStep) {
      this.setStep({
        ...this.getSteps.find(step => step.id === this.getStep.id)
      })
    }
    if (!this.getRelated.length) {
      this.fetchProductRelated()
    }
    this.selectedProducts = this.getOptions.pa_additionals
  },
  methods: {
    ...mapMutations({
      setStep: 'customizer/setStep',
      setAdditionals: 'customizer/setAdditionals'
    }),
    ...mapActions('customizer', ['fetchProductRelated']),
    selectProduct(item) {
      const products = JSON.parse(JSON.stringify(this.selectedProducts))
      const inArray = products.findIndex(product => product.id === item.id)

      if (inArray !== -1 && products.length > 0) {
        products.splice(inArray, 1)
      } else {
        products.push(item)
      }
      // inArray !== -1 && products.length > 0 ? products.splice(inArray, 1) : products.push(item)

      this.selectedProducts = products
      this.setAdditionals(products)
    },
    changeQuantity(e, item) {
      const products = JSON.parse(JSON.stringify(this.selectedProducts))
      const inArray = products.findIndex(product => product.id === item.id)

      products[inArray].quantity = parseInt(e.target.value)
      this.selectedProducts = products
      this.setAdditionals(products)
    },
    changeQuantityValue(type, item) {
      const products = JSON.parse(JSON.stringify(this.selectedProducts))
      const inArray = products.findIndex(product => product.id === item.id)
      if (type === 'minus') {
        products[inArray].quantity -= 1
      } else {
        products[inArray].quantity += 1
      }
      this.selectedProducts = products
      this.setAdditionals(products)
    }
  }
}
</script>

<style scoped lang="scss">
.related {
  padding: 25px 0 25px 25px;
  height: 650px;
  box-sizing: border-box;
  @media (max-width: 480px) {
    padding: 25px 0;
    height: auto;
  }
  .products {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0;
    margin: 0;
    overflow-y: auto;
    height: 100%;
    padding-right: 25px;
    @media (max-width: 480px) {
      padding-right: 0;
    }
    li {
      flex-basis: 49%;
      display: flex;
      align-items: center;
      padding: 15px;
      border: 1px solid #efefef;
      border-radius: 5px;
      margin-bottom: 11px;
      cursor: pointer;
      font-weight: 500;
      box-sizing: border-box;
      transition: all .2s;
      position: relative;
      justify-content: space-between;
      flex-direction: row;
      @media (max-width: 768px) {
        flex-basis: auto;
        margin-bottom: 15px;
      }

      @media (max-width: 480px) {
        width: 100%;
        margin-bottom: 10px;
      }

      &.selected, &:hover {
        border: 1px solid #3c3c3c;
      }

      .image {
        width: 50%;

        img {
          max-width: 100%;
          height: auto;
        }
      }

      .details {
        padding: 25px 0 20px 25px;
        width: 50%;
        @media (max-width: 768px) {
          width: 100%;
        }
          p {
            margin: 20px 0 0 0;
            color: #3c3c3c;
            &.name {
              font-weight: 600;
              padding-bottom: 15px;
              font-size: 14px;
              line-height: 20px;
              &:after {
                content: '';
                width: 50px;
                height: 1px;
                background: #EFEFEF;
                display: block;
                margin-top: 20px;
              }
            }
            &.price {
              font-weight: 600;
              font-size: 16px;
              line-height: 18px;
              color: #3C3C3C;
            }
            &:last-child {
              margin: 0;
            }
          }
      }

      .top-bar {
        position: absolute;
        top: 15px;
        right: 15px;
        display: flex;

        .quantity-input {
          display: flex;
          flex: 0 0 80px;
          height: 30px;
          margin-right: 15px;

          button {
            background-color: #fff;
            border: 1px solid #E6E6E6;
            box-shadow: none;
            display: inline-flex;
            align-items: center;
            cursor: pointer;
            transition: all .2s;

            &:hover {
              background-color: #f9f9f9;
            }

            &:first-child {
              border-radius: 4px 0px 0px 4px;
              border-right: none;
            }

            &:last-child {
              border-radius: 0px 4px 4px 0px;
              border-left: none;
            }
          }

          .input-value {
            border: 1px solid #efefef;
            padding: 0 15px;
            display: inline-flex;
            align-items: center;
            font-weight: 600;
            color: #3c3c3c;
          }
        }

        .checkbox {
          label {
            width: 30px;
            height: 30px;
            border: 1px solid #efefef;
            border-radius: 4px;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            transition: all .2s;

            svg {
              opacity: 0;
            }

          }

          &.selected label svg {
            opacity: 1;
          }
        }
      }

    }
  }
}
</style>
